<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      报表统计源数据管理
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.spCode"
          placeholder="资金商code"
          class="public-inp md5"
        />
        <Input
          v-model="query.sku"
          placeholder="sku编码code"
          class="public-inp md5"
        />
        <Select
          v-model="query.code"
          placeholder="数据源类型"
          class="md5"
          style="width: 300px"
        >
          <Option v-for="item in codeList" :value="item.code" :key="item.code"
            >{{ item.name }}
          </Option> </Select
        ><br />
        <Select
          v-model="query.year"
          placeholder="请选择统计年份"
          class="public-inp md5"
        >
          <Option v-for="item in yearList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Select
          v-model="query.month"
          placeholder="请选择统计月份"
          class="public-inp md5"
        >
          <Option v-for="item in monthList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'report.data.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          v-access="'report.data.query'"
          @click="getList()"
          >查询</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-sync"
          @click="syncCheckData()"
          :disabled="isDisabled"
          v-access="'report.data.edit'"
          >一键同步数据
        </Button>
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="editFn(row)">编辑</a>
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        sku: "",
        spCode: "",
        year: "",
        month: "",
        code: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 100,
          fixed: "left",
        },
        {
          title: "年/月",
          key: "year",
          width: 85,
          render: (h, params) => {
            let name = params.row.year + "/" + params.row.month;
            return h("div", name);
          },
        },
        {
          title: "数据源类型",
          key: "code",
          width: 220,
          render: (h, params) => {
            let code = params.row.code;
            let name = "";
            if (code == "SellIn") name = "SellIn-[表check_purchase_data]";
            else if (code == "SellOut") name = "SellOut-[表check_sale_data]";
            else if (code == "Stock") name = "Stock-[表check_stock_data]";
            else if (code == "InOut") name = "InOut-[表check_inout_data]";
            return h("div", name);
          },
        },
        {
          title: "关联表ID",
          key: "refId",
          width: 100,
        },
        {
          title: "资金商code",
          key: "spCode",
          width: 110,
        },
        {
          title: "资金商名称",
          key: "spName",
          width: 200,
        },
        {
          title: "sku编码",
          key: "skuCode",
          width: 100,
        },
        {
          title: "sku名称",
          key: "skuName",
          width: 200,
        },
        {
          title: "库存",
          key: "stock",
          width: 80,
        },
        {
          title: "单据日期",
          key: "createDate",
          width: 100,
        },
        {
          title: "状态",
          key: "status",
          width: 80,
        },
        {
          title: "创建时间",
          key: "createTime",
          width: 150,
        },
        {
          title: "更新时间",
          key: "updateTime",
          width: 150,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      isDisabled: false,
      codeList: [
        {
          code: "InOut",
          name: "InOut-对应同步表check_inout_data表",
        },
        {
          code: "SellOut",
          name: "SellOut-对应同步check_sale_data表",
        },
        {
          code: "Stock",
          name: "Stock-对应同步check_stock_data表",
        },
        {
          code: "SellIn",
          name: "SellIn-对应同步check_purchase_data表",
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    syncCheckData() {
      if (this.query.year == "") {
        this.$Message.error("请选择报表年份！");
        return false;
      }

      if (this.query.month == "") {
        this.$Message.error("请选择报表月份！");
        return false;
      }

      this.$Modal.confirm({
        title: "提示",
        content: `确认统计源数据${
          this.query.year + "/" + this.query.month
        }会先删除后新增`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.isDisabled = true;
          let params = {
            year: this.query.year,
            month: this.query.month,
          };

          if (params.beginDate == "" || params.endDate == "") {
            this.$Message.error("统计时间区间不允许为空！");
            return false;
          }

          this.$api.submitReportSyncData(params).then((res) => {
            if (res.code == "200") {
              this.$Message.success("提交成功");
              this.$nextTick(() => {
                this.getList();
              });
            } else {
              this.$Message.error(res.message);
            }
            this.isDisabled = false;
          });
        },
      });
    },
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getReportSyncDataList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.spCode = "";
      this.query.sku = "";
      this.query.year = "";
      this.query.month = "";
      this.query.code = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    beforeStateChange() {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "切换确认",
          content: "您确认要切换状态吗？",
          onOk: resolve,
          oncancel: reject,
        });
      });
    },
    stateChange(d, v) {
      if (v) {
        this.$api.enableReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("启用成功");
            this.getList();
          } else {
            this.$Message.error("启用失败");
          }
        });
      } else {
        this.$api.disableReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("禁用成功");
            this.getList();
          } else {
            this.$Message.error("禁用失败");
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/data.vue